goog.provide("shadow.js.shim.module$dayjs$locale$it");
goog.provide("module$shadow_js_shim_module$dayjs$locale$it");
shadow.js.shim.module$dayjs$locale$it = shadow.js.nativeProvides["dayjs/locale/it"] = require("dayjs/locale/it");
module$shadow_js_shim_module$dayjs$locale$it.default = shadow.js.shim.module$dayjs$locale$it;
